import { formData, isCompletelyEmpty, removeEmptyFields } from '../../utils/data';

const MedicalCertTable = ({ medCert, medName, med, medRest }) => {
  const hasCert = !isCompletelyEmpty(medCert);
  const hasName = !isCompletelyEmpty(medName);
  const hasMed = !isCompletelyEmpty(med);
  const hasRest = !isCompletelyEmpty(medRest);

  if (!hasCert && !hasName && !hasMed && !hasRest) return null;

  const isMX = formData.Body.DriverRequest.DriverData.DriverLicense.LicenseCountry === 'MX';

  return (
    <>
      <th>Medical Certifications</th>
      <table className="table table-striped table-bordered">
        <thead>
          <tr>
            {isMX && <th>Medical Number</th>}
            <th>Issue Date</th><th>Expiration Date</th>
            {!isMX && <><th>SPE Issue Date</th><th>SPE Expiration Date</th><th>Med WE Issue Date</th><th>Med WE Expiration Date</th></>}
            <th>Status Code</th><th>Self Certification</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            {isMX && <td>{medCert.MedicalNumber}</td>}
            <td>{medCert.IssueDate}</td>
            <td>{medCert.ExpirationDate}</td>
            {!isMX && <>
              <td>{medCert.SPE_EffectiveDate}</td>
              <td>{medCert.SPE_ExpDate}</td>
              <td>{medCert.Waiver_Or_Exempt_EffectiveDate}</td>
              <td>{medCert.Waiver_Or_Exempt_ExpDate}</td>
            </>}
            <td>{medCert.StatusCode?.split(' - ')[1] || medCert.StatusCode}</td>
            <td>{medCert.SelfCertificationCode?.split(' - ')[1] || medCert.SelfCertification?.split(' - ')[1]}</td>
          </tr>
        </tbody>
      </table>
      {hasRest && 
      <>
      <th>Medical Certificate Restrictions</th>
      <table className="table table-striped table-bordered">
        <thead>
          <tr><th>Value</th></tr>
        </thead>
        <tbody>
          {medRest.map((r, idx) => (
            <tr key={idx}>
              <td>{r.RestrictionText}</td>
            </tr>
          ))}
        </tbody>
      </table>
      </>
      }
      {(hasName || hasMed) &&
      <>
      <th>Medical Examiner Detail</th>
      <table className="table table-striped table-bordered">
        <thead>
          <tr>
            <th>First Name</th><th>Middle Name</th><th>Last Name</th><th>Registry Number</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{medName.FirstName}</td>
            <td>{medName.MiddleName}</td>
            <td>{medName.LastName}</td>
            <td>{med.RegistryNumber}</td>
          </tr>
        </tbody>
      </table>
      <table className="table table-striped table-bordered">
        <thead>
          <tr>
            <th>Medical #</th><th>Specialty</th><th>State</th><th>Phone</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{med.LicenseNumber}</td>
            {med?.SpecialityCode?.split('-') ? <td>{med?.SpecialityCode.split('-')[1]}</td> : <td>{med?.SpecialityCode}</td>}
            <td>{med.JurisCode}</td>
            <td>{med.TelephoneNumber}</td>
          </tr>
        </tbody>
      </table>
      </>
      }
    </>
  );
};

export default MedicalCertTable;
